import { BRAND } from "../lib/brand";

// Official LIVYVIO horizontal wordmark. Preserves aspect ratio + transparency.
// eager=true for the header wordmark (above the fold); lazy elsewhere.
export function Logo({ className = "h-8", eager = false, alt = "LIVYVIO" }) {
  return (
    <img
      src={BRAND.wordmark}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={`${className} w-auto object-contain select-none`}
      draggable={false}
    />
  );
}
